module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.entity,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择券种",
      "prop": "promotionCode"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: ((_vm.entity.promotionInfo || {}).name),
      callback: function($$v) {
        _vm.$set((_vm.entity.promotionInfo || {}), "name", $$v)
      },
      expression: "(entity.promotionInfo||{}).name"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.showSearchDiag
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生成数量",
      "prop": "genNum"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.entity.genNum),
      callback: function($$v) {
        _vm.$set(_vm.entity, "genNum", _vm._n($$v))
      },
      expression: "entity.genNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "渠道",
      "prop": "dispatchChannelId"
    }
  }, [_c('promotion-dispatch-channel-select', {
    model: {
      value: (_vm.entity.dispatchChannelId),
      callback: function($$v) {
        _vm.$set(_vm.entity, "dispatchChannelId", $$v)
      },
      expression: "entity.dispatchChannelId"
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    ref: "searchDiag",
    attrs: {
      "appendToBody": true,
      "title": "查询活动"
    }
  }, [_c('promotion-info-search', {
    on: {
      "row-dblclick": _vm.onItemSelected
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4feb658","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/act/promotionCoupon/Form.vue
// module id = 354
// module chunks = 0